export const data = {
  titleSelect: 'Tarjetas guardadas',
  titleCreate: 'Nueva tarjeta',
  titleEdit: 'Editar Tarjeta',
  name: 'Nombre del titular de la tarjeta',
  nameHolder: 'Nombre y apellidos',
  info: 'Número de tarjeta',
  cardHolder: '4242 4242 4242 4242',
  monthHolder: '01/29',
  cvcHolder: '1234',
  save: 'Deseo guardar esta tarjeta.',
  list: 'LISTA DE TARJETAS GUARDADAS',
  buttonText: 'Agregar',
};

export const paymentInstallments = [
  {
    months: 3,
    min: 299,
    max: 599,
    taxe: 0.0297,
  },
  {
    months: 6,
    min: 600,
    max: 899,
    taxe: 0.0549,
  },
  {
    months: 9,
    min: 900,
    max: 1199,
    taxe: 0.0925,
  },
  {
    months: 12,
    min: 1200,
    max: 1799,
    taxe: 0.1253,
  },
  {
    months: 18,
    min: 1800,
    max: 2399,
    taxe: 0.1680,
  },
  {
    months: 24,
    min: 2400,
    max: 100000,
    taxe: 0.2421,
  },
];

export const currencyInstallments = {
  MX: 'MXN',
};
